import { useState, useEffect, useCallback } from 'react';
import { Preferences } from '@capacitor/preferences';

/**
 * Хук для хранения значений в Capacitor Preferences (mobile application only).
 * @param key — ключ хранения
 * @param initialValue — начальное значение
 * @returns [значение, функция установки]
 */
export const useMobileStorage = <T>(key: string, initialValue: T): [T, (value: T) => Promise<void>] => {
  const [storedValue, setStoredValue] = useState<T>(initialValue);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await Preferences.get({ key });
        if (result.value !== null) {
          setStoredValue(JSON.parse(result.value));
        }
      } catch (error) {
        console.error('Ошибка при загрузке из Preferences:', error);
      }
    };

    load().then();
  }, [key]);

  const setValue = useCallback(async (value: T) => {
    try {
      const valueToStore = JSON.stringify(value);
      await Preferences.set({ key, value: valueToStore });
      setStoredValue(value);
    } catch (error) {
      console.error('Ошибка при сохранении в Preferences:', error);
    }
  }, [key]);

  return [storedValue, setValue];
};
